import Popover2 from 'components/popovers/Popover2';
import config from 'config';
import React from 'react';
import styles from './AiIgnoredMemoriesHint.module.scss';

interface IgnoredMemoryHintProps {
  show?: boolean;
}

const IgnoredMemoryHint: React.FC<React.PropsWithChildren<IgnoredMemoryHintProps>> = ({
  children,
  show,
}) => {
  if (!show) return React.isValidElement(children) ? children : <>{children}</>;

  return (
    <Popover2
      fixed
      position="left"
      isOpen
      offset={[20, 0]}
      target={<span style={{ display: 'inline-flex' }}>{children}</span>}
      targetArrow={false}
      withSurface={false}
    >
      <div className={styles.inlineHintBase} style={{ right: config.scrollbarWidth + 16 }}>
        <span className={styles.link}>
          <div className={styles.heading}>You just ignored a memory</div>
          <div className={styles.body}>
            It will now be hidden from your timeline.
            <br />
            You can modify your filters through the options menu to reveal and/or restore it.
          </div>
        </span>
      </div>
    </Popover2>
  );
};

export default IgnoredMemoryHint;
